module.exports = __webpack_public_path__ + "static/media/400101_02.ca949054.png";